import type { StatusTone } from "@/lib/status-tone";
import { cn } from "@/lib/utils";

const TONE_CLASS: Record<StatusTone, string> = {
  good: "bg-primary/10 text-primary",
  warn: "bg-amber-500/15 text-amber-800",
  bad: "bg-destructive/10 text-destructive",
  neutral: "bg-muted text-muted-foreground",
};

/** A small mono count pill for tabs, summary tiles and the sidebar nav. */
export function QueueCountBadge({
  count,
  tone = "neutral",
  className,
}: {
  count: number;
  tone?: StatusTone;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex h-4 min-w-4 items-center justify-center rounded-full px-1.5 font-mono text-[10px] leading-none tabular-nums",
        TONE_CLASS[tone],
        className,
      )}
    >
      {count}
    </span>
  );
}
